import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/pricing-1.png'
import _imports_1 from '@/assets/images/pricing-2.png'
import _imports_2 from '@/assets/images/pricing-3.png'


const _hoisted_1 = { class: "pricing-area pb-75 position-relative z-1" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = {
  class: "nav nav-tabs justify-content-center pricing-tabs",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_4 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = { class: "row justify-content-center" }
const _hoisted_9 = {
  class: "col-xl-4 col-md-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_10 = { class: "pricing-single-item" }
const _hoisted_11 = { class: "pricing-content" }
const _hoisted_12 = {
  class: "col-xl-4 col-md-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_13 = { class: "pricing-single-item active" }
const _hoisted_14 = { class: "pricing-content" }
const _hoisted_15 = {
  class: "col-xl-4 col-md-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_16 = { class: "pricing-single-item" }
const _hoisted_17 = { class: "pricing-content" }
const _hoisted_18 = { class: "row justify-content-center" }
const _hoisted_19 = { class: "col-xl-4 col-md-6" }
const _hoisted_20 = { class: "pricing-single-item" }
const _hoisted_21 = { class: "pricing-content" }
const _hoisted_22 = { class: "col-xl-4 col-md-6" }
const _hoisted_23 = { class: "pricing-single-item active" }
const _hoisted_24 = { class: "pricing-content" }
const _hoisted_25 = { class: "col-xl-4 col-md-6" }
const _hoisted_26 = { class: "pricing-single-item" }
const _hoisted_27 = { class: "pricing-content" }
const _hoisted_28 = { class: "row justify-content-center" }
const _hoisted_29 = { class: "col-xl-4 col-md-6" }
const _hoisted_30 = { class: "pricing-single-item" }
const _hoisted_31 = { class: "pricing-content" }
const _hoisted_32 = { class: "col-xl-4 col-md-6" }
const _hoisted_33 = { class: "pricing-single-item active" }
const _hoisted_34 = { class: "pricing-content" }
const _hoisted_35 = { class: "col-xl-4 col-md-6" }
const _hoisted_36 = { class: "pricing-single-item" }
const _hoisted_37 = { class: "pricing-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[30] || (_cache[30] = _createElementVNode("div", {
        class: "section-title mw-860 m-auto text-center",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("span", { class: "top-title" }, "باقات الاشتراكات"),
        _createElementVNode("h2", null, "باقات اشتراك تنافسية")
      ], -1)),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link", ['tab', { active: _ctx.activeTab === 'internet' }]]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveTab('internet')))
          }, " اشتراك أساسي ", 2)
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link", ['tab', { active: _ctx.activeTab === 'tv' }]]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveTab('tv')))
          }, " اشتراك عائلي ", 2)
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link", ['tab', { active: _ctx.activeTab === 'homeSecurity' }]]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveTab('homeSecurity')))
          }, " اشتراك VIP ", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ignite d-block" }, " احصل على أفضل جودة بـ 15 دولار شهرياً ", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"pricing\"><h3>باقة المبتدئين</h3><p> اشتراك لمدة شهر واحد. استمتع بكل القنوات العالمية بجودة عالية وثبات مستمر. </p><div class=\"d-flex justify-content-between align-items-center speed-mbps\"><div class=\"download\"><span class=\"speed\">عدد الأجهزة</span><span class=\"mbps\"><span>1</span> جهاز</span></div><div class=\"download\"><span class=\"speed\">الدعم الفني</span><span class=\"mbps\"><span>24</span> ساعة</span></div></div><span class=\"unlimited\">استخدام غير محدود</span><h2>$ 15.00<sub>/ شهرياً</sub></h2>", 6)),
                  _createVNode(_component_RouterLink, {
                    to: "/contact-us",
                    class: "btn active"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ignite d-block" }, " الأكثر طلباً في أوروبا بـ 25 دولار ", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _cache[7] || (_cache[7] = _createStaticVNode("<img src=\"" + _imports_1 + "\" alt=\"pricing\"><h3>الباقة العائلية</h3><p> اشتراك مرن ومناسب للعائلات. دعم كامل للقنوات الترفيهية والرياضية. </p><div class=\"d-flex justify-content-between align-items-center speed-mbps\"><div class=\"download\"><span class=\"speed\">عدد الأجهزة</span><span class=\"mbps\"><span>2</span> جهاز</span></div><div class=\"download\"><span class=\"speed\">جودة البث</span><span class=\"mbps\"><span>4K</span> UHD</span></div></div><span class=\"unlimited\">استخدام غير محدود</span><h2>$ 25.00<sub>/ شهرياً</sub></h2>", 6)),
                  _createVNode(_component_RouterLink, {
                    to: "/contact-us",
                    class: "btn active"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "ignite d-block" }, " تغطية شاملة لكل القنوات العالمية ", -1)),
                _createElementVNode("div", _hoisted_17, [
                  _cache[10] || (_cache[10] = _createStaticVNode("<img src=\"" + _imports_2 + "\" alt=\"pricing\"><h3>باقة الـ VIP</h3><p> اشتراك متكامل مع مكتبة أفلام ضخمة وتحديثات يومية مستمرة. </p><div class=\"d-flex justify-content-between align-items-center speed-mbps\"><div class=\"download\"><span class=\"speed\">عدد الأجهزة</span><span class=\"mbps\"><span>3</span> أجهزة</span></div><div class=\"download\"><span class=\"speed\">أولوية الدعم</span><span class=\"mbps\"><span>قصوى</span></span></div></div><span class=\"unlimited\">استخدام غير محدود</span><h2>$ 40.00<sub>/ شهرياً</sub></h2>", 6)),
                  _createVNode(_component_RouterLink, {
                    to: "/contact-us",
                    class: "btn active"
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 'internet']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "ignite d-block" }, " باقة التجربة السنوية ", -1)),
                _createElementVNode("div", _hoisted_21, [
                  _cache[13] || (_cache[13] = _createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"pricing\"><h3>الباقة الأساسية سنوي</h3><p> اشتراك سنوي اقتصادي يضمن لك توفير المال والحصول على أفضل الخدمات. </p><div class=\"d-flex justify-content-between align-items-center speed-mbps\"><div class=\"download\"><span class=\"speed\">عدد الأجهزة</span><span class=\"mbps\"><span>1</span> جهاز</span></div><div class=\"download\"><span class=\"speed\">الدعم الفني</span><span class=\"mbps\"><span>دائم</span></span></div></div><span class=\"unlimited\">استخدام غير محدود</span><h2>$ 120.00<sub>/ سنة</sub></h2>", 6)),
                  _createVNode(_component_RouterLink, {
                    to: "/contact-us",
                    class: "btn active"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "ignite d-block" }, " العرض العائلي المميز للعام ", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _cache[16] || (_cache[16] = _createStaticVNode("<img src=\"" + _imports_1 + "\" alt=\"pricing\"><h3>الباقة العائلية سنوي</h3><p> خيارك الأفضل في أوروبا للمشاهدة العائلية المستقرة على مدار السنة. </p><div class=\"d-flex justify-content-between align-items-center speed-mbps\"><div class=\"download\"><span class=\"speed\">عدد الأجهزة</span><span class=\"mbps\"><span>2</span> جهاز</span></div><div class=\"download\"><span class=\"speed\">جودة البث</span><span class=\"mbps\"><span>4K</span> UHD</span></div></div><span class=\"unlimited\">استخدام غير محدود</span><h2>$ 200.00<sub>/ سنة</sub></h2>", 6)),
                  _createVNode(_component_RouterLink, {
                    to: "/contact-us",
                    class: "btn active"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "ignite d-block" }, " باقة VIP السنوية الشاملة ", -1)),
                _createElementVNode("div", _hoisted_27, [
                  _cache[19] || (_cache[19] = _createStaticVNode("<img src=\"" + _imports_2 + "\" alt=\"pricing\"><h3>باقة الـ VIP سنوي</h3><p> تمتع بأقصى مستويات الترفيه في ألمانيا وأوروبا لمدة 12 شهراً كاملة. </p><div class=\"d-flex justify-content-between align-items-center speed-mbps\"><div class=\"download\"><span class=\"speed\">عدد الأجهزة</span><span class=\"mbps\"><span>3</span> أجهزة</span></div><div class=\"download\"><span class=\"speed\">أولوية الدعم</span><span class=\"mbps\"><span>قصوى</span></span></div></div><span class=\"unlimited\">استخدام غير محدود</span><h2>$ 350.00<sub>/ سنة</sub></h2>", 6)),
                  _createVNode(_component_RouterLink, {
                    to: "/contact-us",
                    class: "btn active"
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 'tv']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "ignite d-block" }, " باقة دعم الخبراء ", -1)),
                _createElementVNode("div", _hoisted_31, [
                  _cache[22] || (_cache[22] = _createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"pricing\"><h3>الدعم الفني والتقني</h3><p> خدمة إضافية للعملاء الذين يحتاجون مساعدة تقنية متقدمة في إعدادات البث. </p><div class=\"d-flex justify-content-between align-items-center speed-mbps\"><div class=\"download\"><span class=\"speed\">المساعدة</span><span class=\"mbps\"><span>عن بعد</span></span></div><div class=\"download\"><span class=\"speed\">التوفر</span><span class=\"mbps\"><span>24/7</span></span></div></div><span class=\"unlimited\">خدمة احترافية</span><h2>$ 5.00<sub>/ شهرياً</sub></h2>", 6)),
                  _createVNode(_component_RouterLink, {
                    to: "/contact-us",
                    class: "btn active"
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("span", { class: "border-style" }, "اطلب الخدمة", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "ignite d-block" }, " تجهيز الشاشات الذكية ", -1)),
                _createElementVNode("div", _hoisted_34, [
                  _cache[25] || (_cache[25] = _createStaticVNode("<img src=\"" + _imports_1 + "\" alt=\"pricing\"><h3>خدمة إعداد الشاشات</h3><p> نقوم بتنصيب جميع البرامج المطلوبة لتعمل الخدمة على شاشتك بكفاءة 100%. </p><div class=\"d-flex justify-content-between align-items-center speed-mbps\"><div class=\"download\"><span class=\"speed\">التجهيز</span><span class=\"mbps\"><span>شامل</span></span></div><div class=\"download\"><span class=\"speed\">الضمان</span><span class=\"mbps\"><span>متاح</span></span></div></div><span class=\"unlimited\">خدمة احترافية</span><h2>$ 10.00<sub>/ مرة</sub></h2>", 6)),
                  _createVNode(_component_RouterLink, {
                    to: "/contact-us",
                    class: "btn active"
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("span", { class: "border-style" }, "اطلب الخدمة", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "ignite d-block" }, " باقة الأجهزة المساعدة ", -1)),
                _createElementVNode("div", _hoisted_37, [
                  _cache[28] || (_cache[28] = _createStaticVNode("<img src=\"" + _imports_2 + "\" alt=\"pricing\"><h3>اشتراك البث المباشر</h3><p> إضافة قنوات إخبارية ورياضية حصرية تتطلب سرعات عالية وتغطية خاصة. </p><div class=\"d-flex justify-content-between align-items-center speed-mbps\"><div class=\"download\"><span class=\"speed\">التغطية</span><span class=\"mbps\"><span>عالمية</span></span></div><div class=\"download\"><span class=\"speed\">الجودة</span><span class=\"mbps\"><span>فائقة</span></span></div></div><span class=\"unlimited\">استخدام غير محدود</span><h2>$ 20.00<sub>/ شهرياً</sub></h2>", 6)),
                  _createVNode(_component_RouterLink, {
                    to: "/contact-us",
                    class: "btn active"
                  }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createElementVNode("span", { class: "border-style" }, "اطلب الخدمة", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 'homeSecurity']
        ])
      ])
    ])
  ]))
}